import { BookOpen, Video, GraduationCap, Users, Hash, Play } from 'lucide-react';
import { Avatar } from '@chakra-ui/react';
import MissedQuestions from '../../components/student/Cards/MissedQuestions';
import QRCode from "qrcode.react";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../components/student/Layout/layout";
import { getAllStudentChaptersRequest } from "../../modules/students-modules/chapters/Actions";
import {
  getLiveVideoRequest,
  setLiveVideoSeenRequest,
} from "../../modules/students-modules/videos/Actions";
import { getActiveAnnouncementsRequest } from "../../modules/students-modules/announcements/Actions";
import AnnouncementsCarousel from "../../components/student/AnnouncementsCarousel";

const StudentHome = ({ t }) => {
  const baseUrl = "https://asquera.com/asquera";
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.userData);
  const liveVideo = useSelector((state) => state.chapterVideos.liveVideo);
  const announcements = useSelector((state) => state.studentAnnouncements.announcements);
  const [showAnnouncements, setShowAnnouncements] = useState(false);

  useEffect(() => {
    dispatch(getAllStudentChaptersRequest());
    dispatch(getLiveVideoRequest());
    dispatch(getActiveAnnouncementsRequest());
  }, []);

  // Check if this is the first visit and show announcements
  useEffect(() => {
    const hasSeenAnnouncements = localStorage.getItem('hasSeenAnnouncements');
    if (!hasSeenAnnouncements && announcements && announcements.length > 0) {
      setShowAnnouncements(true);
    }
  }, [announcements]);

  const handleCloseAnnouncements = () => {
    setShowAnnouncements(false);
    localStorage.setItem('hasSeenAnnouncements', 'true');
  };
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Layout color="main_1" bg="white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        {/* Welcome Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                     {/* User Info Card */}
           <div className="relative">
             <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
               {/* Premium Ribbon */}
               {userData?.grade?.id == 10 && (
                 <div className="absolute -top-3 -left-3 z-10">
                   <div className="flex items-center">
                     <span className="bg-yellow-400 text-white font-bold px-4 py-1 rounded-tr-xl rounded-bl-xl shadow-lg text-xs tracking-widest uppercase" style={{ letterSpacing: "0.1em" }}>
                       Premium
                     </span>
                   </div>
                 </div>
               )}
               <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4">
                 <h2 className="text-xl font-semibold text-white">
                   Welcome {userData?.name} to Asquera
                 </h2>
               </div>

               <div className="p-6">
                 <div className="flex items-start space-x-4 mb-6">
                   {userData?.subject?.logo ? (
                     <div className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0">
                       <Avatar
                         name={userData?.subject?.name}
                         src={baseUrl + "/" + userData?.subject?.logo}
                         borderRadius="8px"
                         size="lg"
                         background="transparent"
                         h="100%"
                         w="100%"
                       />
                     </div>
                   ) : (
                     <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                       <BookOpen className="w-8 h-8 text-white" />
                     </div>
                   )}
                                 <div className="flex-1 space-y-2">
                   <div className="flex items-center space-x-2 text-gray-700">
                     <BookOpen className="w-4 h-4 text-orange-500" />
                     <span className="text-sm">Subject: {userData?.subject?.name}</span>
                   </div>
                   <div className="flex items-center space-x-2 text-gray-700">
                     <Users className="w-4 h-4 text-orange-500" />
                     <span className="text-sm">Group: {userData?.group?.name}</span>
                   </div>
                   <div className="flex items-center space-x-2 text-gray-700">
                     <Hash className="w-4 h-4 text-orange-500" />
                     <span className="text-sm">Code: {userData?.user_name}</span>
                   </div>
                 </div>
               </div>

               {/* QR Code */}
               <div className="flex justify-center">
                 <div className="bg-gray-50 p-4 rounded-xl">
                   <div className="w-48 h-48 bg-white border-2 border-gray-200 rounded-lg flex items-center justify-center">
                     <QRCode
                       size={200}
                       value={`https://asquera.com/scan-code/${userData?.id}/attendence`}
                     />
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>

          {/* Live Video Card */}
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                <Video className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900">Live Video</h3>
            </div>

            {liveVideo.length === 0 ? (
              <div className="bg-gray-50 rounded-xl p-8 text-center">
                <Video className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-600 font-medium">
                  There isn't any available live videos
                </p>
              </div>
            ) : (
              <button className="w-full bg-gradient-to-r from-red-500 to-red-600 text-white font-medium py-3 px-6 rounded-xl hover:from-red-600 hover:to-red-700 transition-all duration-200 flex items-center justify-center space-x-2"
                onClick={() => {
                  dispatch(setLiveVideoSeenRequest(liveVideo?.[0]?.id));
                  window.open(liveVideo?.[0]?.zoom_link);
                }}
              >
                <Play className="w-5 h-5" />
                <span>Join {liveVideo[0]?.title} live video</span>
              </button>
            )}
          </div>
        </div>

        {/* Missed Questions Section */}
        <MissedQuestions />
      </div>

      {/* Announcements Carousel Modal */}
      <AnnouncementsCarousel
        announcements={announcements}
        isOpen={showAnnouncements}
        onClose={handleCloseAnnouncements}
      />
    </Layout >
  );
};

export default withTranslation()(StudentHome);
